import React from "react"
import Layout from "../components/layout"
import { graphql, Link } from "gatsby"
import Treatment from "../components/global/treatment"
import SEO from "../components/global/seo"

const TreatmentPage = ({ data }) => {
  return (
    <React.Fragment>
      <SEO title="Treatments" />
      <Layout>
        <div className="container mt-5">
          <h1 className="display-4 text-center brand">
            Treatments di Vivaldy Skin Clinic
          </h1>
          <div className="row px-auto">
            {data.treatments.edges.map(treatment => {
              return (
                <div
                  className="col-10 col-sm-10 col-md-6 col-lg-4 mt-5 px-auto wrap-card"
                  key={treatment.node.id}
                >
                  <Link to={`/treatment/${treatment.node.id}`}>
                    <Treatment treatment={treatment.node} />
                  </Link>
                </div>
              )
            })}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default TreatmentPage

export const query = graphql`
  {
    treatments: allWordpressWpTreatments {
      edges {
        node {
          title
          slug
          featured_media {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 2000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
